import { Directive } from '@angular/core';
import { CdkStepLabel } from '@angular/cdk/stepper';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[sutStepLabel]',
})
export class SutStepLabelDirective extends CdkStepLabel {}
